<template>
	<div>
		<form class="form-container" @submit.prevent="register">
			<input 
				:placeholder="$t('email')"
				v-model="email_general" 
				type="email"
				maxlength="50" 
				:class="{ error: $v.email_general.$error }"
				@blur="$v.email_general.$touch()"
			/>
			<template v-if="$v.email_general.$error">
				<p v-if="!$v.email_general.required" class="errorMessage">
				{{ $t('emailGeneralReq') }}
				</p>
			</template>
			<template v-if="$v.email_general.$error">
				<p v-if="!$v.email_general.email" class="errorMessage">
				{{ $t('emailValid') }}
				</p>
			</template>
			<input 
				:placeholder="$t('contactNo')"
				v-model="contact_no" 
				oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
				maxlength="13" 
				:class="{ error: $v.contact_no.$error }"
				@blur="$v.contact_no.$touch()"
			/>
			<template v-if="$v.contact_no.$error">
				<p v-if="!$v.contact_no.required" class="errorMessage">
  				{{ $t('contactNoReq') }}
				</p>
        <div v-else class="errorMessage">
          {{ $t('contactRegexValidation') }}<br />
        </div>
			</template>
			<div class="optionalData">
				<p class="optional">{{ $t('optional') }}</p>
				<!-- <input 
				:placeholder="$t('invoicingEmail')"
				v-model="email_invoice" 
				type="email" 
				class="bgOptional"
				:class="{ error: $v.email_invoice.$error }"
				@blur="$v.email_invoice.$touch()"
				name="email_invoice" 
				value />
				<template v-if="$v.email_invoice.$error">
					<p v-if="!$v.email_invoice.email" class="errorMessage">
					{{ $t('emailValid') }}
					</p>
				</template> -->
							<input 
				:placeholder="$t('contactFname')"
				v-model="contact_fname" 
				type="text"
				maxlength="30"
				class="bgOptional" 
				:class="{ error: $v.contact_fname.$error }"
				/>
				<!-- <template v-if="$v.contact_fname.$error">
					<p v-if="!$v.contact_fname.required" class="errorMessage">
					{{ $t('contactFnameReq') }}
					</p>
				</template> -->
				<input 
					:placeholder="$t('contactLname')"
					v-model="contact_lname" 
					type="text"
					maxlength="30"
					class="bgOptional" 
					:class="{ error: $v.contact_lname.$error }"
				/>
				<!-- <template v-if="$v.contact_lname.$error">
					<p v-if="!$v.contact_lname.required" class="errorMessage">
					{{ $t('contactLnameReq') }}
					</p>
				</template> -->
				<input 
				:placeholder="$t('website')" 
				v-model="website_url" 
				type="url" 
				class="bgOptional"
				maxlength="100"  
				name="website_url" 
				:class="{ error: $v.website_url.$error }"
				@blur="$v.website_url.$touch()"
				value />
				<template v-if="$v.website_url.$error">
					<p v-if="!$v.website_url.url" class="errorMessage">
					{{ $t('validUrlReq') }}
					</p>
				</template>
			</div>
			<br/>
			<button :disabled="$v.$invalid" class="add-btn" type="submit" name="button">
				{{ $t('save') }}
			</button>

			<p v-if="$v.anyError" class="errorMessage">
				{{ $t('fillInReq') }}
			</p>

			<ul>
				<li v-for="(error, index) in errors" :key="index">{{ error }}</li>
			</ul>
		</form>
	</div>
</template>

<script>
import NProgress from 'nprogress'
import { required, url, email, helpers } from 'vuelidate/lib/validators'
const contactNoRegex = helpers.regex('contact_no', /^([+][0-9]{11,12})$/)

export default {
  data() {
    return {
      email_general: this.clientDetails.email_general,
      email_invoice: this.clientDetails.email_invoice,
      contact_fname: this.clientDetails.contact_fname,
      contact_lname: this.clientDetails.contact_lname,
      contact_no: this.clientDetails.contact_no,
  	  website_url: this.clientDetails.website_url,
      errors: null
    }
  },
  validations: {
    email_general: { required, email },
	  email_invoice: { email },
    contact_fname: { },
    contact_lname: { },
    contact_no: { required, contactNoRegex },
	  website_url: { url }
  },
  methods: {
    register() {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        NProgress.start()
        this.$store
          .dispatch('client/addClient', {
            email_general: this.email_general,
            email_invoice: this.email_invoice,
            contact_fname: this.contact_fname,
            contact_lname: this.contact_lname,
            contact_no: this.contact_no,
            website_url: this.website_url
          })
          .then(() => {
            alert(this.$t('companyContactsSaved'))
            NProgress.done()
            this.$emit('exit', true)
          })
          .catch(err => {
            this.errors = err.response.data.errors
            NProgress.done()
          })
      }
    }
  },
  props: {
    clientDetails: {
      type: Object,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>

.optionalData {
  background-color: var(--grey-light);
  border: 1px solid var(--grey);
  padding: 0 20px;
  width: 100%;
}
.optional {
  text-align: center;
  letter-spacing: 5px;
  color: var(--bg);
}
.form-container {
  //position: absolute;
  background: #fff;
  padding: 30px;
  border-radius: 10px;
  box-shadow: 0px 0px 8px 0px #000;
  width: auto;
}

a:visited {
  color: #2c3e50;
}

.button,
button {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
  background: linear-gradient(to right, $secondary, $secondary-dark);
  font-size: 1.5em;
  color: white;
  border: none;
  text-transform: uppercase;
  letter-spacing: 0.15em;
  outline: none;
  margin: auto;
}

button:disabled,
button[disabled]{
  border: 1px solid #999999;
  background-color: #cccccc;
  color: #666666;
  cursor: context-menu;
}

form {
  display: flex;
  text-align: left;
  flex-direction: column;

  p {
    color: red;
  }
}

input {
  display: block;
  box-sizing: border-box;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: .25rem;
  transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;
  width: 100%;
  height: 2.6em;
  padding: 0.5em;
  margin-bottom: 1em;
  font: 1em 'Lato', Helvetica, sans-serif;
}

.bgOptional {
  background: rgb(252, 250, 250);
}

h1 {
  margin-top: 0;
}

.add-btn {
	background: var(--primaryDark);
	color: var(--bright);
	border-radius: 5px;
	padding: 0.3em;
	letter-spacing: 3px;
	width: 80%;
}

.errorMessage {
  font-size: 0.8em;
  margin-top: -10px;
  color: var(--primaryDark);
}

@media screen and (max-width: 560px){
.optionalData {
    padding: 10px;
  }
}
</style>
